export var TranslationsKeys;
(function (TranslationsKeys) {
    TranslationsKeys["SAVE_BUTTON"] = "security.saveChanges";
    TranslationsKeys["EDIT_BUTTON"] = "security.editButton";
    TranslationsKeys["CANCEL_BUTTON"] = "security.cancelButton";
    TranslationsKeys["DELETE_CONFIGURATION_LINK"] = "security.deleteConfigurationLink";
    TranslationsKeys["LEARN_MORE"] = "security.learnMore";
    TranslationsKeys["CONFIGURED_ENABLED"] = "security.configuredEnabled";
    TranslationsKeys["CONFIGURED_DISABLED"] = "security.configuredDisabled";
    TranslationsKeys["UNCONFIGURED"] = "security.unconfigured";
    TranslationsKeys["CONFIGURE_BUTTON"] = "security.configureButton";
    TranslationsKeys["TITLE"] = "security.title";
    TranslationsKeys["SUBTITLE"] = "security.subTitle";
    TranslationsKeys["SSL_TITLE"] = "security.sslTitle";
    TranslationsKeys["SSL_SUBTITLE"] = "security.sslSubTitle";
    TranslationsKeys["SSL_FORM_TITLE"] = "security.sslFormTitle";
    TranslationsKeys["SSL_TOGGLE_ENABLED_LABEL"] = "security.sslToggleEnabledLabel";
    TranslationsKeys["SSL_TOGGLE_DISABLED_LABEL"] = "security.sslToggleDisabledLabel";
    TranslationsKeys["EDIT_FORM_ENABLE_LABEL"] = "security.editFormEnableLabel";
    TranslationsKeys["EDIT_FORM_DISABLE_LABEL"] = "security.editFormDisableLabel";
    TranslationsKeys["SSH_TITLE"] = "security.sshTitle";
    TranslationsKeys["SSH_SUBTITLE"] = "security.sshSubTitle";
    TranslationsKeys["SSH_FORM_TITLE"] = "security.sshFormTitle";
    TranslationsKeys["TOAST_SUCCESS"] = "security.toastSuccess";
    TranslationsKeys["TOAST_DELETE_SUCCESS"] = "security.toastDeleteSuccess";
    TranslationsKeys["SSH_BANNER_ALERT_MESSAGE"] = "security.sshBannerAlertMessage";
    TranslationsKeys["SSH_BANNER_ALERT_LINK_TEXT"] = "security.sshBannerAlertLinkText";
    TranslationsKeys["SSL_UPLOAD_BOTH_ERROR"] = "security.sslUploadBothError";
    TranslationsKeys["MESSAGE_API_FAILURE"] = "security.somethingWentWrong";
    TranslationsKeys["SSL_SELECT_INPUT_PLACEHOLDER"] = "security.ssl.selectInput.placeholder";
})(TranslationsKeys || (TranslationsKeys = {}));
//# sourceMappingURL=constants.js.map